export default {
  min: {
    title:
      'Bezorging naar jouw locatie: Bedrag nodig om het minimale bestelbedrag te bereiken (Subtotaal excl. bezorgkosten & fooi)',
    description:
      'Sorry, je kunt nog niet bestellen. {{name}} heeft een minimaal bestelbedrag van {{threshold}} ingesteld (excl. bezorgkosten)',
  },
  max: {
    title: 'Maximale bestelwaarde voor bezorging bereikt (Totaal excl. bezorgkosten)',
    description:
      'Je bestelling heeft de maximaal toegestane waarde van {{threshold}} voor online bezorging bereikt. Voor bestellingen boven dit bedrag kun je ons direct contacteren zodat wij de bezorging voor je kunnen regelen. Bedankt voor je begrip!',
  },
};
